/*
 * Hervorhebung "Du sparst <Betrag>" in BF26-Preislisten (price-list.ll-design--bf26). Laedt in BEIDEN Designs
 * (layout/theme.liquid): BF26-Preislisten gibt es auch im Classic-Design (Desktop-Sticky, ll_design_override in
 * sections/main-product.liquid). Ohne BF26-Preisliste auf der Seite tut das Script nichts.
 *
 * "Du sparst 700,00 €": Der Betrag ist hervorgehoben (<strong class="ll-savings__amount">). Beim Laden rendert das
 * Liquid (snippets/price-list.liquid, snippets/price-list-product-card.liquid). Das Theme (PriceSavings, Varianten-
 * wechsel) und assets/ll-bf26.js (Early Access) schreiben den Text aber als reinen Text neu - danach wird der Betrag
 * hier wieder ausgezeichnet. Vorlage ist der Theme-String "Du sparst %amount%" (snippets/js-variables.liquid).
 */
const template = window.themeVariables?.strings?.savingsFrom || "";
const [prefix = "", suffix = ""] = template.split("%amount%");

const highlight = (element) => {
  if (element.querySelector(".ll-savings__amount")) {
    return;
  }
  const text = element.textContent.trim();
  if (!text || !text.startsWith(prefix.trim()) || (suffix && !text.endsWith(suffix.trim()))) {
    return;
  }
  const amount = text.slice(prefix.trim().length, suffix.trim() ? text.length - suffix.trim().length : undefined).trim();
  if (!amount) {
    return;
  }

  const strong = document.createElement("strong");
  strong.className = "ll-savings__amount";
  strong.textContent = amount;
  element.replaceChildren(document.createTextNode(prefix), strong, document.createTextNode(suffix));
};

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    const element = (mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement)?.closest("price-savings");
    if (element) {
      highlight(element);
    }
  });
});

const watch = (root) => {
  root.querySelectorAll("price-list.ll-design--bf26 price-savings").forEach((element) => {
    if (element.llSavingsWatched) {
      return;
    }
    element.llSavingsWatched = true;
    highlight(element);
    observer.observe(element, { childList: true, characterData: true, subtree: true });
  });
};

if (prefix || suffix) {
  watch(document);
  // Nachgeladene Preise (Quick View, Infinite Scroll, Section Rendering) ebenfalls beobachten.
  let queued = false;
  new MutationObserver(() => {
    if (!queued) {
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        watch(document);
      });
    }
  }).observe(document.body, { childList: true, subtree: true });
}
